var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { Divider, Heading, Image, Link, List, Text } from 'pcln-design-system';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES, MARKS } from '@contentful/rich-text-types';
import ContentfulImage from '../ContentfulImage';
var InlineImage = styled(Image)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
var InlineContentfulImage = styled(ContentfulImage)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
var getEmbeddedAsset = function (node, props) {
    var _a, _b;
    var assetProps = node.data.target;
    if ((_b = (_a = assetProps === null || assetProps === void 0 ? void 0 : assetProps.file) === null || _a === void 0 ? void 0 : _a.contentType) === null || _b === void 0 ? void 0 : _b.includes('image')) {
        var url = assetProps.file.url;
        return React.createElement(InlineImage, __assign({ src: "https:".concat(url), width: 20, height: 20, mx: 1 }, props));
    }
};
var getInlineEmbeddedEntry = function (node, props) {
    var entryProps = node.data.target;
    if ((entryProps === null || entryProps === void 0 ? void 0 : entryProps.contentTypeId) === 'image') {
        return React.createElement(InlineContentfulImage, __assign({}, entryProps, { mx: 1 }, props));
    }
};
var Paragraph = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React.createElement(Text.p, __assign({}, props), children);
};
var BoldText = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Text.span, __assign({ fontWeight: 'bold' }, props), children));
};
var ItalicText = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Text.span, __assign({ fontStyle: 'italic' }, props), children));
};
var LinkText = function (_a) {
    var children = _a.children, node = _a.node, props = __rest(_a, ["children", "node"]);
    var href = node.data.uri;
    return (React.createElement(Link, __assign({ target: '_blank', href: href }, props), children));
};
function getMark(type, text, props) {
    switch (type) {
        case MARKS.BOLD:
            return React.createElement(BoldText, __assign({}, props), text);
        case MARKS.ITALIC:
            return React.createElement(ItalicText, __assign({}, props), text);
    }
}
function getNode(type, node, children, props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var fontSize = props.fontSize, propsNoFontSize = __rest(props, ["fontSize"]);
    switch (type) {
        case BLOCKS.HEADING_1:
            return React.createElement(Heading.h1, __assign({}, propsNoFontSize), children);
        case BLOCKS.HEADING_2:
            return React.createElement(Heading.h2, __assign({}, propsNoFontSize), children);
        case BLOCKS.HEADING_3:
            return React.createElement(Heading.h3, __assign({}, propsNoFontSize), children);
        case BLOCKS.HEADING_4:
            return React.createElement(Heading.h4, __assign({}, propsNoFontSize), children);
        case BLOCKS.HEADING_5:
            return React.createElement(Heading.h5, __assign({}, propsNoFontSize), children);
        case BLOCKS.HEADING_6:
            return React.createElement(Heading.h6, __assign({}, propsNoFontSize), children);
        case BLOCKS.PARAGRAPH:
            return React.createElement(Paragraph, __assign({}, props), children);
        case BLOCKS.HR:
            return React.createElement(Divider, __assign({}, props));
        case BLOCKS.UL_LIST:
            return React.createElement(List.ul, __assign({}, props), children);
        case BLOCKS.OL_LIST:
            return React.createElement(List.ol, __assign({}, props), children);
        case BLOCKS.EMBEDDED_ASSET:
            return getEmbeddedAsset(node, props);
        case INLINES.EMBEDDED_ENTRY:
            return getInlineEmbeddedEntry(node, props);
        case INLINES.HYPERLINK:
            return (React.createElement(LinkText, __assign({}, props, { node: node }), children));
    }
}
var options = function (props) {
    var _a, _b;
    return {
        renderText: function (text) { return text.split('\n').flatMap(function (text, i) { return [i > 0 && React.createElement("br", null), text]; }); },
        renderMark: (_a = {},
            _a[MARKS.BOLD] = function (text) { return getMark(MARKS.BOLD, text, props); },
            _a[MARKS.ITALIC] = function (text) { return getMark(MARKS.ITALIC, text, props); },
            _a),
        renderNode: (_b = {},
            _b[BLOCKS.HEADING_1] = function (node, children) { return getNode(BLOCKS.HEADING_1, node, children, props); },
            _b[BLOCKS.HEADING_2] = function (node, children) { return getNode(BLOCKS.HEADING_2, node, children, props); },
            _b[BLOCKS.HEADING_3] = function (node, children) { return getNode(BLOCKS.HEADING_3, node, children, props); },
            _b[BLOCKS.HEADING_4] = function (node, children) { return getNode(BLOCKS.HEADING_4, node, children, props); },
            _b[BLOCKS.HEADING_5] = function (node, children) { return getNode(BLOCKS.HEADING_5, node, children, props); },
            _b[BLOCKS.HEADING_6] = function (node, children) { return getNode(BLOCKS.HEADING_6, node, children, props); },
            _b[BLOCKS.PARAGRAPH] = function (node, children) { return getNode(BLOCKS.PARAGRAPH, node, children, props); },
            _b[BLOCKS.HR] = function () { return getNode(BLOCKS.HR, null, null, props); },
            _b[BLOCKS.UL_LIST] = function (node, children) { return getNode(BLOCKS.UL_LIST, node, children, props); },
            _b[BLOCKS.OL_LIST] = function (node, children) { return getNode(BLOCKS.OL_LIST, node, children, props); },
            _b[BLOCKS.EMBEDDED_ASSET] = function (node, children) { return getNode(BLOCKS.EMBEDDED_ASSET, node, children, props); },
            _b[INLINES.EMBEDDED_ENTRY] = function (node, children) { return getNode(INLINES.EMBEDDED_ENTRY, node, children, props); },
            _b[INLINES.HYPERLINK] = function (node, children) { return getNode(INLINES.HYPERLINK, node, children, props); },
            _b),
    };
};
/** @public */
function ContentfulRichText(_a) {
    var body = _a.body, props = __rest(_a, ["body"]);
    return React.createElement(React.Fragment, null, documentToReactComponents(body, options(props)));
}
export default ContentfulRichText;
var templateObject_1, templateObject_2;
//# sourceMappingURL=ContentfulRichText.js.map